import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteWorkspaceGoggle } from "api/services/workspace-service";
import { WORKSPACE_GOGGLES_QUERY_KEY } from "hooks/goggles/queryKeys";
import { useAuthContext } from "hooks/useAuthContext";

export const useDeleteWorkspaceGoggle = () => {
    const queryClient = useQueryClient();
    const { userState } = useAuthContext();
    const workspaceId = userState.user.selectedWorkspace.workspaceId;

    const mutation = useMutation({
        mutationFn: (goggleId: string): Promise<void> =>
            deleteWorkspaceGoggle({ workspaceId, goggleId }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: WORKSPACE_GOGGLES_QUERY_KEY });
        }
    });

    return {
        deleteGoggle: mutation.mutateAsync,
        deletingGoggle: mutation.isPending,
    };
};
